import { render, staticRenderFns } from "./TodayCallDuration.vue?vue&type=template&id=54169141&scoped=true"
import script from "./TodayCallDuration.vue?vue&type=script&lang=js"
export * from "./TodayCallDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54169141",
  null
  
)

export default component.exports